import { Component } from '@angular/core';
import { Config, ModalController, NavParams } from '@ionic/angular';
import { sortBy, filter, debounce } from 'lodash';

@Component({
  selector: 'telus-column-filter',
  templateUrl: 'column-filter.html',
  styleUrls: ['./column-visibility.scss'],
})
export class ColumnFilterComponent {
  ios: boolean;

  filters: any;
  columnName: string;
  pageType: string;
  searchText = '';
  sortedOptionsArray;
  getFilterValue;
  shouldBeSorted: false;
  dataChanged = false;

  constructor(
    private config: Config,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {
    this.getFilterValue = debounce(({ target: { value } }) => {
      this.searchText = (value as string).toLowerCase();
      this.sortedOptionsArray = this.sortedOptions();
    }, 300);
  }

  ionViewWillEnter() {
    this.ios = this.config.get('mode') === `ios`;

    this.pageType = this.navParams.get('pageType');
    this.filters = this.navParams.get('filters');
    this.columnName = this.navParams.get('columnName');
    this.shouldBeSorted = this.navParams.get('sorted');
    this.sortedOptionsArray = this.sortedOptions();
  }

  sortedOptions() {
    const options = this.searchOptions();
    return this.shouldBeSorted
      ? sortBy(options, (option) => option.title)
      : options;
  }

  searchOptions() {
    const options =
      this.filters.dict[this.columnName]?.options.length !== 0
        ? this.filters.dict[this.columnName].options
        : this.filters.dict[this.columnName].list;
    if (this.searchText.length === 0) {
      return options;
    }

    return filter(
      options,
      (option) => option.title.toLowerCase().indexOf(this.searchText) !== -1
    );
  }

  filtersChanged(item) {
    this.dataChanged = true;

    this.filters.dict[this.columnName].dict[item.title].checked =
      !this.filters.dict[this.columnName].dict[item.title].checked;
  }

  applyFilters() {
    this.dismiss(this.filters);
  }

  dismiss(data?: any) {
    const returnedValue = this.dataChanged ? data : false;
    this.modalCtrl.dismiss(data);
  }

  searchEnter(e: Event) {
    e.preventDefault();
  }

  selectAll(check: boolean) {
    this.markAll(check);
  }

  markAll(checked: boolean) {
    this.filters.dict[this.columnName].list.forEach((option) => {
      option.checked = checked;
    });
  }

  clearAll() {
    this.filters.dict[this.columnName].searchText = '';
    this.filters.dict[this.columnName].list.forEach((x) => {
      x.checked = true;
    });
  }
}
